import loaders from './loaders';
import parsers from './parsers';
import exporters from './exporters';

export default {
  loaders,
  parsers,
  exporters,
};
